import React from "react";

function OperationalProgressBar({ percent, color }) {
  const safePercent = Math.max(0, Math.min(100, percent));
//console.log("OperationalProgressBar rendered with:", { percent, color });
  return (
    <div
      className="oh-progress-bar"
      role="progressbar"
      aria-valuenow={safePercent}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`Health progress ${safePercent}%`}
    >
      <div
        className={`oh-progress-fill ${color}`}
        style={{ width: `${safePercent}%` }}
      />
    </div>
  );
}

export default OperationalProgressBar;